import { render, staticRenderFns } from "./riepilogoMensile.html?vue&type=template&id=3185c5bc&scoped=true&"
import script from "./RiepilogoMensile.vue?vue&type=script&lang=js&"
export * from "./RiepilogoMensile.vue?vue&type=script&lang=js&"
import style0 from "./RiepilogoMensile.vue?vue&type=style&index=0&id=3185c5bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3185c5bc",
  null
  
)

export default component.exports